<template>
  <div style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%;padding: 0;">
      <el-aside style="height: 100%;width: 50%;padding: 0">
        <!--      1-->
        <el-row class="elRow" :gutter="15">
          <el-col :span="24">
            <div class="style3">
              切断加工生产概况
            </div>
          </el-col>
          <el-col :span="5" style="margin-left: 10px" class="elCol">
            <div class="style1" style="background-color: #04cc7c;">&nbsp;在岗工人&nbsp;</div>
            <div class="style2">{{ fromData.worker_num }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #206fd5">&nbsp;开工物件&nbsp;</div>
            <div class="style2">{{ fromData.wujian_num }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4973d;">&nbsp;切断重量&nbsp;</div>
            <div class="style2">{{ fromData.cut_daily_num + 'KG' }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4653d;">&nbsp;加工重量&nbsp;</div>
            <div class="style2">{{ fromData.process_daily_num + 'KG' }}</div>
          </el-col>
          <!--      2-->
          <el-col :span="24" class="elCol1">
            <div class="style3">
              涂装生产概况
            </div>
          </el-col>
          <el-col :span="5" style="margin-left: 10px" class="elCol">
            <div class="style1" style="background-color: #04cc7c;">&nbsp;在岗工人&nbsp;</div>
            <div class="style2">{{ fromData1.worker_num }}</div>
          </el-col>
          <el-col :span="6" class="elCol">
            <div class="style1" style="background-color: #206fd5">&nbsp;前处理面积&nbsp;</div>
            <div class="style2">{{ fromData1.pretreatment_area + 'm²' }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4973d;">&nbsp;喷涂面积&nbsp;</div>
            <div class="style2">{{ fromData1.spray_area + 'm²' }}</div>
          </el-col>
          <!--      3-->
          <el-col :span="24" class="elCol1">
            <div class="style3">
              组立生产概况
            </div>
          </el-col>
          <el-col :span="5" style="margin-left: 10px" class="elCol">
            <div class="style1" style="background-color: #04cc7c;">&nbsp;在岗工人&nbsp;</div>
            <div class="style2">{{ fromData2.worker_num }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #206fd5">&nbsp;开工物件&nbsp;</div>
            <div class="style2">{{ fromData2.wujian_num }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4973d;">&nbsp;日产量&nbsp;</div>
            <div class="style2">{{ fromData2.cut_daily_num }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4653d;">&nbsp;开工产线&nbsp;</div>
            <div class="style2">{{ fromData2.assembly_daily_num }}</div>
          </el-col>
          <!--      4-->
          <el-col :span="24" class="elCol1">
            <div class="style3">
              型材检查概况
            </div>
          </el-col>
          <el-col :span="5" style="margin-left: 10px" class="elCol">
            <div class="style1" style="background-color: #04cc7c;">&nbsp;在岗工人&nbsp;</div>
            <div class="style2">{{ fromData2.xc_worker_num }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4973d;">&nbsp;检查数量&nbsp;</div>
            <div class="style2">{{ toDayData.totalCnt }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4653d;">&nbsp;检查重量&nbsp;</div>
            <div class="style2">{{ toDayData.totalWeight }}</div>
          </el-col>
          <!--      5-->
          <el-col :span="24" class="elCol1">
            <div class="style3">
              玻璃检查概况
            </div>
          </el-col>
          <el-col :span="5" style="margin-left: 10px" class="elCol">
            <div class="style1" style="background-color: #04cc7c;">&nbsp;在岗工人&nbsp;</div>
            <div class="style2">{{ fromData2.boli_worker_num }}</div>
          </el-col>
          <el-col :span="5" class="elCol">
            <div class="style1" style="background-color: #e4973d;">&nbsp;检查数量&nbsp;</div>
            <div class="style2">{{ fromData2.boli_total_cnt  }}</div>
          </el-col>
        </el-row>
      </el-aside>
      <el-main style="height: 100%;width: 50%;padding: 0">
        <el-row style="height: 100%;">
          <el-col :span="24" style="height: 33%">
            <!--  生产实绩-->
            <div class="divSize" v-loading="produceActualOutputLoading" element-loading-text="数据加载中"
                 style="width: 100%;height: 90%;" :id="produceActualOutputId"/>
          </el-col>
          <el-col :span="24" style="height: 33%">
            <!--  生产实绩-->
            <div class="divSize" v-loading="ptActualOutputLoading" element-loading-text="数据加载中"
                 style="width: 100%;height: 90%;" :id="ptActualOutputId"/>
          </el-col>
          <el-col :span="24" style="height: 34%;">
            <!--  组立面积生产实绩-->
            <div class="divSize" v-loading="zuliAreaProductionOutputLoading" element-loading-text="数据加载中"
                 style="width: 100%;height: 85%;" :id="zuliAreaProductionOutputId"/>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {useDateFormat} from "@vueuse/core";
import * as echarts from "echarts";
import {nanoid} from "nanoid";

export default {
  name: "ZhiZaoKanBan2",
  components: {},
  data() {
    return {
      produceActualOutputId: nanoid(),
      ptActualOutputId: nanoid(),
      zuliAreaProductionOutputId: nanoid(),
      currentTime: '',
      fromData: {
        dateDay: this.getDateFormat(),
      },
      fromData1: {},
      fromData2: {},
      toDayData: {},
      //加工生产实绩
      produceActualOutputLoading: false,
      produceActualOutput: {
        title: [
          {
            text: '加工生产实绩',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '加工实绩(kg)',
            interval: 20,
            axisLabel: {
              formatter: function (value) {
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '累计实绩(kg)',
            interval: 20,
            axisLabel: {
              formatter: function (value) {
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: '计划',
            type: 'bar',
            // yAxisIndex:0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'bar',
            yAxisIndex: 0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计计划',
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计实绩',
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      //物件喷涂日生产生产实绩
      ptActualOutput: {
        title: [
          {
            text: '涂装喷涂生产实绩',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          bottom: '20',
          data: ['计划', '实绩', '累计计划', '累计实绩']
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '面积(㎡)',
            axisLabel: {
              formatter: function (value) {
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '累计面积(㎡)',
            axisLabel: {
              formatter: function (value) {
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: '计划',
            type: 'bar',
            label: {
              position: 'inside'
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '实绩',
            type: 'bar',
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '累计计划',
            type: 'line',
            color: '#fac858',
            label: {},
            yAxisIndex: 1,
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '累计实绩',
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      },
      ptActualOutputLoading: false,
      ptActualData: {},
      productionData: {},
      countDays: [],
      countDayList: [],
      month: this.getDateFormat(),
      //物件日生产面积实绩
      zuliAreaProductionOutput: {
        title: [
          {
            text: '组立生产实绩(面积)',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '面积(㎡)',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value) {
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '累计面积(㎡)',
            min: 0,
            max: 10,
            interval: 0.5,
            axisLabel: {
              formatter: function (value) {
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: '计划',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计计划',
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计实绩',
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliAreaProductionOutputLoading: false
    }
  },
  mounted() {
  },
  unmounted() {
  },
  methods: {
    dateFormat() {
      this.currentTime = useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss dddd')
    },
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    getProcessFromData() {
      this.$axios.post('mfg/processCalendar/getProcessFromData').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.fromData = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getPaintingFromData() {
      this.$axios.post('mfg/paintingCalendar/getPaintingAreaData').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.fromData1 = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getAssemblyFromData() {
      this.$axios.post('mfg/assemblyCalendar/getAssemblyFromData').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.fromData2 = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    //生产实绩
    getCountDays(month) {
      const d = new Date(month)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      this.countDays = new Date(y, m, 0).getDate();
      for (let i = 1; i <= this.countDays; i++) {
        //准备天数集合
        this.countDayList.push(i)
      }
    },
    //1
    async getProduceActual() {
      let params = {countDayList: this.countDayList, thing: null, month: this.month};
      this.produceActualOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/processProduce/getProduceActual', params);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.produceActualOutput.xAxis[0].data = res.data.xAxis
        this.produceActualOutput.series[0].data = res.data.planList
        this.produceActualOutput.series[1].data = res.data.actualList
        //this.produceActualOutput.series[2].data = res.data.differenceList
        this.produceActualOutput.series[2].data = res.data.accumulatePlanList
        this.produceActualOutput.series[3].data = res.data.accumulateActualList
        let maxA = this.$common.getMaxValue(res.data.planList, res.data.actualList)

        //let a = this.$common.getDivisor(Math.max(...res.data.actualList))
        this.produceActualOutput.yAxis[0].max = Math.ceil(maxA / 5) * 6
        this.produceActualOutput.yAxis[0].interval = Math.round(this.produceActualOutput.yAxis[0].max / 5 * 100) / 100

        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList, res.data.accumulateActualList)
        this.produceActualOutput.yAxis[1].max = Math.ceil(maxB / 5) * 6
        this.produceActualOutput.yAxis[1].interval = Math.round(this.produceActualOutput.yAxis[1].max / 5 * 100) / 100
        // let b = this.$common.getDivisor(Math.max(...res.data.accumulateActualList))
        // this.produceActualOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.accumulateActualList)/b)* (b + 5)
        // this.produceActualOutput.yAxis[1].interval = Math.round(this.produceActualOutput.yAxis[1].max/5*100)/100
      }
      this.renderEcharts(this.produceActualOutputId, this.produceActualOutput)
      this.produceActualOutputLoading = false
    },
    //喷涂生产实绩
    async getPtProduceActual() {
      this.ptActualData.day = this.getDateFormat()
      this.ptActualData.wuJianId = ""
      this.ptActualData.tableName = "mfg_spray_plan_actual"
      this.ptActualOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/tuzhuangProduce/getProduceActual', this.ptActualData);
      console.log(res.data)
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.ptActualOutput.xAxis[0].data = res.data.xAxis
        this.ptActualOutput.series[0].data = res.data.areaPlanList
        this.ptActualOutput.series[1].data = res.data.areaActualList
        this.ptActualOutput.series[2].data = res.data.accumulateAreaPlanList
        this.ptActualOutput.series[3].data = res.data.accumulateAreaActualList

        let maxA = this.$common.getMaxValue(res.data.areaPlanList, res.data.areaActualList)
        let maxB = this.$common.getMaxValue(res.data.accumulateAreaPlanList, res.data.accumulateAreaActualList)

        this.ptActualOutput.yAxis[0].max = Math.ceil(maxA / 5) * 6
        this.ptActualOutput.yAxis[0].interval = Math.round(this.ptActualOutput.yAxis[0].max / 5 * 100) / 100

        this.ptActualOutput.yAxis[1].max = Math.ceil(maxB / 5) * 6
        this.ptActualOutput.yAxis[1].interval = Math.round(this.ptActualOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts(this.ptActualOutputId, this.ptActualOutput)
      this.ptActualOutputLoading = false
    },
    //面积生产实绩
    async getZuliAreaProduction() {
      this.productionData.day = this.getDateFormat()
      this.productionData.wuJianId = null
      this.zuliAreaProductionOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliActualProduction/getZuliAreaProduction', this.productionData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.zuliAreaProductionOutput.xAxis[0].data = res.data.xAxis
        this.zuliAreaProductionOutput.series[0].data = res.data.planList
        this.zuliAreaProductionOutput.series[1].data = res.data.actualList
        this.zuliAreaProductionOutput.series[2].data = res.data.accumulatePlanList
        this.zuliAreaProductionOutput.series[3].data = res.data.accumulateActualList

        let maxA = this.$common.getMaxValue(res.data.planList, res.data.actualList)
        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList, res.data.accumulateActualList)
        this.zuliAreaProductionOutput.yAxis[0].max = Math.ceil(maxA / 5) * 6
        this.zuliAreaProductionOutput.yAxis[0].interval = Math.round(this.zuliAreaProductionOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliAreaProductionOutput.yAxis[1].max = Math.ceil(maxB / 5) * 6
        this.zuliAreaProductionOutput.yAxis[1].interval = Math.round(this.zuliAreaProductionOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts(this.zuliAreaProductionOutputId, this.zuliAreaProductionOutput)
      this.zuliAreaProductionOutputLoading = false
    },
    async getToDayData() {
      let {data: res} = await this.$axios.get('bus/xingcaiCharts/getXingcai02');
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.toDayData = res.data
    },
  },
  created() {
    this.timer1 = setInterval(() => {
      this.dateFormat();
    }, 1000)
    var currentDate = new Date();
    this.getCountDays(currentDate);
    this.getPtProduceActual()
    this.getProduceActual()
    this.getZuliAreaProduction()
    this.getProcessFromData()
    this.getPaintingFromData()
    this.getAssemblyFromData()
    this.getToDayData()
    this.timer2 = setInterval(() => {
      this.getProcessFromData()
      this.getPtProduceActual()
      this.getProduceActual()
      this.getZuliAreaProduction()
      this.getPaintingFromData()
      this.getAssemblyFromData()
      this.getToDayData()
    }, 300000)
  },
  beforeUnmount() {
  }
}
</script>

<style scoped>
.style1 {
  color: whitesmoke;
  border-radius: 4px;
  font-size: 28px;
}

.style2 {
  font-weight: bold;
  font-size: 23px;
}

.divSize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.style3 {
  font-size: 18px;
  border-left: 3px solid steelblue;
  padding-left: 15px;
  height: 25px;
  text-align: left;
  width: 100%;
  margin-left: 10px;
  margin-top: 10px;
}

.elRow {
  text-align: center;
  height: 100%;
}

.elCol {
  margin-top: -50px;
}

.elCol1 {
  margin-top: -20px;
}

</style>